import React, { useState, useEffect } from "react";
import { Autocomplete, Checkbox, Collapse, TextField } from "@mui/material";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import NumberInput from "../../Inputs/NumberInput";
import ListItem from "@mui/material/ListItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import ArrowRightRoundedIcon from "@mui/icons-material/ArrowRightRounded";
import ListItemText from "@mui/material/ListItemText";
import List from "@mui/material/List";
import { produce } from "immer";

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

const CategoryItemAutocomplete = ({
                                      category,
                                      width,
                                      categoryItems,
                                      setCategoryItems,
                                      formValidQuoteDetail
                                  }) => {
    const [value, setValue] = useState([]);

    useEffect(() => {
        const relevantCategoryItems = categoryItems.filter(x => x.productCategoryId === category.id);
        const syncedValue = category.productItems.filter(item => relevantCategoryItems.some((catItem) => catItem.productItemId === item.id)
        );
        setValue(syncedValue);
    }, [categoryItems, category]);

    const handleChange = (event, newValue) => {
        setValue(newValue);

        setCategoryItems((prevState) =>
            produce(prevState, (draft) => {
                for (let i = draft.length - 1; i >= 0; i--) {
                    if (draft[i].productCategoryId === category.id) {
                        draft.splice(i, 1);
                        delete formValidQuoteDetail.current[category.id];
                    }
                }
                
                if (newValue.length > 0) {
                    formValidQuoteDetail.current[category.id] = {};
                }

                newValue.forEach((item) => {
                    draft.push({
                        productItemId: item.id,
                        productItemName: item.name,
                        productCategoryId: category.id,
                        categoryName: category.name,
                        quantity: 1,
                        fields: item.fields.map((field) => ({
                            fieldId: field.id,
                            displayName: field.displayName,
                            uom: field.uom,
                            type: field.type,
                            enumOptions: field.enumOptions,
                            name: field.name,
                            value: "",
                        })),
                    });

                    formValidQuoteDetail.current[category.id][item.id] = {};

                    item.fields?.map((field) => {
                        formValidQuoteDetail.current[category.id][item.id][field.id] = field.type === 4 || field.type === "Boolean";
                    });
                });
            })
        );
    };

    const handleItemQuantityChange = (categoryId, itemId, quantity) => {
        setCategoryItems((prevState) =>
            produce(prevState, (draft) => {
                const index = draft.findIndex(x => x.productItemId === itemId && x.productCategoryId === categoryId);
                if (index !== -1) {
                    draft[index].quantity = quantity;
                }
            })
        );
    };

    return (
        <>
            <Autocomplete
                multiple
                id={`${category.name}-items`}
                options={category.productItems ?? []}
                disableCloseOnSelect
                onChange={handleChange}
                value={value}
                getOptionLabel={(option) => {
                    if (typeof option === "string") {
                        return option;
                    }
                    if (option?.inputValue) {
                        return option.inputValue;
                    }
                    return option.name;
                }}
                selectOnFocus
                clearOnBlur
                handleHomeEndKeys
                renderOption={(props, option, { selected }) => {
                    const { key, ...optionProps } = props;
                    return (
                        <li key={key} {...optionProps}>
                            <Checkbox
                                icon={icon}
                                checkedIcon={checkedIcon}
                                checked={selected}
                            />
                            {option?.name}
                        </li>
                    );
                }}
                sx={{
                    width:
                        width ??
                        {
                            xs: "200px !important",
                            sm: "250px !important",
                            md: "300px !important",
                        },
                }}
                isOptionEqualToValue={(option, value) => option.name === value.name}
                renderInput={(params) => (
                    <TextField
                        {...params}
                        label="Items"
                        placeholder={value.length > 0 ? null : "Select"}
                        sx={{
                            my: 2,
                            width:
                                width ??
                                {
                                    xs: "200px !important",
                                    sm: "250px !important",
                                    md: "300px !important",
                                },
                        }}
                    />
                )}
            />
            <List dense disablePadding>
                <Collapse in={value.length > 0}>
                    {value.map((item) => (
                        <ListItem key={`${category.id}-${item.id}`} divider sx={{my: 1}}>
                            <ListItemIcon sx={{ minWidth: "30px!important" }}>
                                <ArrowRightRoundedIcon />
                            </ListItemIcon>
                            <ListItemText
                                sx={{ maxWidth: "60%" }}
                                primary={
                                    <>
                                        <span style={{ fontWeight: "bold" }}>{item.name}</span>
                                    </>
                                }
                            />
                            <NumberInput
                                min={0}
                                size={"small"}
                                label={"Qty"}
                                value={categoryItems.find(
                                    (x) =>
                                        x.productItemId === item.id &&
                                        x.productCategoryId === category.id
                                )?.quantity}
                                onChange={(newValue) =>
                                    handleItemQuantityChange(category.id, item.id, newValue)
                                }
                            />
                        </ListItem>
                    ))}
                </Collapse>
            </List>
        </>
    );
};

export default CategoryItemAutocomplete;